import { alpha, Box, Button, Stack, styled } from '@mui/material'

export const BannerBox = styled(Box)(({ theme }) => ({
  minHeight: theme.customDimensions.heroBannerMinHeight,
  color: theme.palette.text.primary,
  backgroundSize: 'cover',
  height: '100%',
  py: '65px',
  position: 'relative',
  [theme.breakpoints.down('lg')]: {
    minHeight: '400px',
  },
  [theme.breakpoints.down('md')]: {
    minHeight: 'unset',
    padding: '160px 8px 8px 8px',
    backgroundSize: 'auto 220px',
    backgroundRepeat: 'no-repeat',
  },
}))

export const BannerTextWrapper = styled(Stack)(({ theme }) => ({
  position: 'absolute',
  bottom: 0,
  zIndex: 1,
  backgroundColor: theme.palette.background.light,
  color: theme.palette.text.primary,
  width: '40%',
  textAlign: 'left',
  padding: theme.spacing(4),
  paddingBottom: theme.spacing(2),
  borderTopLeftRadius: theme.spacing(1),
  borderTopRightRadius: theme.spacing(1),
  maxHeight: '90%',
  [theme.breakpoints.down('md')]: {
    maxHeight: 'calc(100vh - 310px)',
    position: 'static',
    left: 0,
    right: 0,
    padding: theme.spacing(2),
    paddingBottom: theme.spacing(4),
    width: '100%',
    maxWidth: 'unset',
    boxShadow: `${alpha(theme.palette.common.black, 0.25)} 0px 4px 4px 0px`,
    marginBottom: theme.spacing(1),
    borderRadius: theme.spacing(1),
    overflow: 'hidden',
  },
}))

export const StyledButton = styled(Button)(({ theme }) => ({
  width: 'fit-content',
  backgroundColor: theme.palette.secondary.main,
  '&:hover': {
    backgroundColor: theme.palette.secondary.dark,
  },
}))

export const StyledReadMoreButton = styled(Button)(({ theme }) => ({
  width: 'fit-content',
  color: theme.palette.secondary.main,
  '&:hover': {
    color: theme.palette.secondary.dark,
  },
}))

export const ImageBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '16px',
  paddingTop: '24px',
  paddingBottom: '14px',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
}))

export const ImageDescriptionWrapper = styled(Box)(({ theme }) => ({
  marginTop: '8px',
  paddingBlock: '2px',

  '.MuiTypography-body1': {
    fontSize: '16px',
    [theme.breakpoints.down('md')]: {
      fontSize: '14px',
    },
  },
}))

export const BannerDescriptionWrapper = styled('div')(({ theme }) => ({
  '&.BannerDescriptionWrapper': {
    height: 'auto',
    overflow: 'hidden',
  },
  '&.BannerDescriptionWrapper p': {
    [theme.breakpoints.down('lg')]: {
      fontSize: '14px',
    },
  },
}))
